import Cookies from 'js-cookie';
import { notification } from 'antd'; 
import axios from 'axios';
import actions from './actions';
import { API } from '../../config/api/index';
import { setItem, removeItem } from '../../utility/localStorageControl';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const loginNotificationError = err => {
  notification.error({
    message: err.response.data.message,
  });
};

const login = (credentials) => {
  return async (dispatch) => {
    try {
      dispatch(loginBegin());
      const response = await axios.post(`${API_ENDPOINT}${API.auth.login}`, credentials);
      const { token, user } = response.data;

      setItem('access_token', token);
      // setItem('refresh_token', refresh_token);
      setItem('user', user);
      Cookies.set('logedIn', true);

      dispatch(loginSuccess(user));
      return { success: true }; // Return success status
    } catch (err) {
      dispatch(loginErr(err.response));
      loginNotificationError(err)
      return { success: false, error: err.response.data }; 
    }
  };
};


const logOut = () => {
  return async (dispatch) => {
    try {
      dispatch(logoutBegin());
      Cookies.remove('logedIn');
      removeItem('access_token');
      removeItem('refresh_token');
      removeItem('user');
      dispatch(logoutSuccess(null));
      // Redirect to login page
      window.location.href = '/';
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut };
